import * as types from '../constants/ActionTypes';
import {
  DASHBOARD_ENDPOINT,
  END_POINT,
  CUSTOMERS_ENDPOINT,
  PROJECTS_ENDPOINT,
} from '../constants/EndPoints';
import { fetchMiddleware } from './MiddlewareActions';
import { getSignedUrlForFile } from './GlobalsActions';
import { receiveProjects } from './ProjectsActions';

// Action Types
export const SET_DASHBOARD_MODAL_VISIBILITY = 'SET_DASHBOARD_MODAL_VISIBILITY';
export const SET_MAINTENANCE_DASHBOARD_MODAL_VISIBILITY =
  'SET_MAINTENANCE_DASHBOARD_MODAL_VISIBILITY';

export const FETCH_DASHBOARD_STATS_REQUEST = 'FETCH_DASHBOARD_STATS_REQUEST';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_FAILURE = 'FETCH_DASHBOARD_STATS_FAILURE';

export const FETCH_DASHBOARD_WEEKLY_STATS_REQUEST =
  'FETCH_DASHBOARD_WEEKLY_STATS_REQUEST';
export const FETCH_DASHBOARD_WEEKLY_STATS_SUCCESS =
  'FETCH_DASHBOARD_WEEKLY_STATS_SUCCESS';
export const FETCH_DASHBOARD_WEEKLY_STATS_FAILURE =
  'FETCH_DASHBOARD_WEEKLY_STATS_FAILURE';

export const FETCH_DASHBOARD_REPORT_REQUEST = 'FETCH_DASHBOARD_REPORT_REQUEST';
export const FETCH_DASHBOARD_REPORT_SUCCESS = 'FETCH_DASHBOARD_REPORT_SUCCESS';
export const FETCH_DASHBOARD_REPORT_FAILURE = 'FETCH_DASHBOARD_REPORT_FAILURE';

export const FETCH_OPERATIONAL_ALERTS_REQUEST =
  'FETCH_OPERATIONAL_ALERTS_REQUEST';
export const FETCH_OPERATIONAL_ALERTS_SUCCESS =
  'FETCH_OPERATIONAL_ALERTS_SUCCESS';
export const FETCH_OPERATIONAL_ALERTS_FAILURE =
  'FETCH_OPERATIONAL_ALERTS_FAILURE';

export const FETCH_EVENT_STATES_REQUEST = 'FETCH_EVENT_STATES_REQUEST';
export const FETCH_EVENT_STATES_SUCCESS = 'FETCH_EVENT_STATES_SUCCESS';
export const FETCH_EVENT_STATES_FAILURE = 'FETCH_EVENT_STATES_FAILURE';

export const FETCH_ALERTS_HISTORY_QUARTERLY_REQUEST =
  'FETCH_ALERTS_HISTORY_QUARTERLY_REQUEST';
export const FETCH_ALERTS_HISTORY_QUARTERLY_SUCCESS =
  'FETCH_ALERTS_HISTORY_QUARTERLY_SUCCESS';
export const FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE =
  'FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE';

export const FETCH_ALERTS_LIFECYCLE_QUARTERLY_REQUEST =
  'FETCH_ALERTS_LIFECYCLE_QUARTERLY_REQUEST';
export const FETCH_ALERTS_LIFECYCLE_QUARTERLY_SUCCESS =
  'FETCH_ALERTS_LIFECYCLE_QUARTERLY_SUCCESS';
export const FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE =
  'FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE';

export const FETCH_ALERTS_YEARLY_TREND_REQUEST =
  'FETCH_ALERTS_YEARLY_TREND_REQUEST';
export const FETCH_ALERTS_YEARLY_TREND_SUCCESS =
  'FETCH_ALERTS_YEARLY_TREND_SUCCESS';
export const FETCH_ALERTS_YEARLY_TREND_FAILURE =
  'FETCH_ALERTS_YEARLY_TREND_FAILURE';

export const UPDATE_OPERATIONAL_ALERT_REQUEST =
  'UPDATE_OPERATIONAL_ALERT_REQUEST';
export const UPDATE_OPERATIONAL_ALERT_SUCCESS =
  'UPDATE_OPERATIONAL_ALERT_SUCCESS';
export const UPDATE_OPERATIONAL_ALERT_FAILURE =
  'UPDATE_OPERATIONAL_ALERT_FAILURE';

export const FETCH_OPERATIONAL_ALERTS_SETTINGS_REQUEST =
  'FETCH_OPERATIONAL_ALERTS_SETTINGS_REQUEST';
export const FETCH_OPERATIONAL_ALERTS_SETTINGS_SUCCESS =
  'FETCH_OPERATIONAL_ALERTS_SETTINGS_SUCCESS';
export const FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE =
  'FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE';

export const UPDATE_OPERATIONAL_ALERTS_SETTINGS_REQUEST =
  'UPDATE_OPERATIONAL_ALERTS_SETTINGS_REQUEST';
export const UPDATE_OPERATIONAL_ALERTS_SETTINGS_SUCCESS =
  'UPDATE_OPERATIONAL_ALERTS_SETTINGS_SUCCESS';
export const UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE =
  'UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE';

export const FETCH_CUSTOMER_LOGO_REQUEST = 'FETCH_CUSTOMER_LOGO_REQUEST';
export const FETCH_CUSTOMER_LOGO_SUCCESS = 'FETCH_CUSTOMER_LOGO_SUCCESS';
export const FETCH_CUSTOMER_LOGO_FAILURE = 'FETCH_CUSTOMER_LOGO_FAILURE';

export const FETCH_DEVICE_TYPES_STATS_WEEKLY_REQUEST =
  'FETCH_DEVICE_TYPES_STATS_WEEKLY_REQUEST';
export const FETCH_DEVICE_TYPES_STATS_WEEKLY_SUCCESS =
  'FETCH_DEVICE_TYPES_STATS_WEEKLY_SUCCESS';
export const FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE =
  'FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE';

export const FETCH_MAINTENANCE_DASHBOARD_REQUEST =
  'FETCH_MAINTENANCE_DASHBOARD_REQUEST';
export const FETCH_MAINTENANCE_DASHBOARD_SUCCESS =
  'FETCH_MAINTENANCE_DASHBOARD_SUCCESS';
export const FETCH_MAINTENANCE_DASHBOARD_FAILURE =
  'FETCH_MAINTENANCE_DASHBOARD_FAILURE';
export const FETCH_MAINTENANCE_REPORT_SENSORS_REQUEST =
  'FETCH_MAINTENANCE_REPORT_SENSORS_REQUEST';
export const FETCH_MAINTENANCE_REPORT_SENSORS_SUCCESS =
  'FETCH_MAINTENANCE_REPORT_SENSORS_SUCCESS';
export const FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE =
  'FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE';

export const SET_CUSTOMER_DASHBOARD_MODAL_VISIBILITY =
  'SET_CUSTOMER_DASHBOARD_MODAL_VISIBILITY';
export const SET_CAME_FROM_CUSTOMER_DASHBOARD =
  'SET_CAME_FROM_CUSTOMER_DASHBOARD';

export const FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST =
  'FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST';
export const FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS =
  'FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS';
export const FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE =
  'FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE';

// Action Creators
export const setDashboardModalVisibility = (isVisible) => ({
  type: SET_DASHBOARD_MODAL_VISIBILITY,
  payload: isVisible,
});

export const setMaintenanceDashboardModalVisibility = (isVisible) => ({
  type: SET_MAINTENANCE_DASHBOARD_MODAL_VISIBILITY,
  payload: isVisible,
});

export const setCustomerDashboardModalVisibility = (isVisible) => ({
  type: SET_CUSTOMER_DASHBOARD_MODAL_VISIBILITY,
  payload: isVisible,
});

export const setCameFromCustomerDashboard = (value) => ({
  type: SET_CAME_FROM_CUSTOMER_DASHBOARD,
  payload: !!value,
});

export const fetchCustomerDashboardData = (customerId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/customer-data/${customerId}`;
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch customer dashboard data';
        dispatch({
          type: FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchDashboardStats = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/stats/${projectId}`;
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_DASHBOARD_STATS_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch dashboard statistics';
        dispatch({
          type: FETCH_DASHBOARD_STATS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_DASHBOARD_STATS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchDashboardWeeklyStats = (projectId, weeks = 1) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_DASHBOARD_WEEKLY_STATS_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/statsWeekly/${projectId}?weeks=${weeks}`;
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_DASHBOARD_WEEKLY_STATS_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch weekly statistics';
        dispatch({
          type: FETCH_DASHBOARD_WEEKLY_STATS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_DASHBOARD_WEEKLY_STATS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchDashboardReport = (reportType, customers = []) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_DASHBOARD_REPORT_REQUEST, reportType });

    try {
      let path = `${DASHBOARD_ENDPOINT}/report/${reportType}`;
      if (customers.length > 0) {
        path += `?customers=${customers.join(',')}`;
      }

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_DASHBOARD_REPORT_SUCCESS,
          payload: response.data,
          reportType,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch report';
        dispatch({
          type: FETCH_DASHBOARD_REPORT_FAILURE,
          error: errorMessage,
          reportType,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_DASHBOARD_REPORT_FAILURE,
        error: error.message,
        reportType,
      });
      throw error;
    }
  };
};

export const fetchOperationalAlerts = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_OPERATIONAL_ALERTS_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/operationalAlerts/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_OPERATIONAL_ALERTS_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch operational alerts';
        dispatch({
          type: FETCH_OPERATIONAL_ALERTS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_OPERATIONAL_ALERTS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchAlertsHistoryQuarterly = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_ALERTS_HISTORY_QUARTERLY_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/alertsHistoryQuaterly/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_ALERTS_HISTORY_QUARTERLY_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch alerts history quarterly';
        dispatch({
          type: FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_ALERTS_HISTORY_QUARTERLY_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchAlertsLifecycleQuarterly = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_ALERTS_LIFECYCLE_QUARTERLY_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/alerts-lifecycle/quarterly-avg/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_ALERTS_LIFECYCLE_QUARTERLY_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch alerts lifecycle quarterly';
        dispatch({
          type: FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_ALERTS_LIFECYCLE_QUARTERLY_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchAlertsYearlyTrend = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_ALERTS_YEARLY_TREND_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/alerts-lifecycle/yearly-trend/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_ALERTS_YEARLY_TREND_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch alerts yearly trend';
        dispatch({
          type: FETCH_ALERTS_YEARLY_TREND_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_ALERTS_YEARLY_TREND_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const updateOperationalAlert = (alertId, updates) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_OPERATIONAL_ALERT_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/operationalAlerts/${alertId}`;

      const options = {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: UPDATE_OPERATIONAL_ALERT_SUCCESS,
          payload: { alertId, updates },
        });

        // Optionally refresh operational alerts
        const state = getState();
        const projectId = state.leaksList?.selectedProject;
        if (projectId) {
          dispatch(fetchOperationalAlerts(projectId));
        }
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to update alert';
        dispatch({
          type: UPDATE_OPERATIONAL_ALERT_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: UPDATE_OPERATIONAL_ALERT_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchOperationalAlertsSettings = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_OPERATIONAL_ALERTS_SETTINGS_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/settings/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_OPERATIONAL_ALERTS_SETTINGS_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch operational alerts settings';
        dispatch({
          type: FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const updateOperationalAlertsSettings = (projectId, settings) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_OPERATIONAL_ALERTS_SETTINGS_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/settings/${projectId}`;

      const options = {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: settings }),
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: UPDATE_OPERATIONAL_ALERTS_SETTINGS_SUCCESS,
          payload: settings,
        });

        // Refresh settings with new values from server
        dispatch(fetchOperationalAlertsSettings(projectId));
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to update operational alerts settings';
        dispatch({
          type: UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: UPDATE_OPERATIONAL_ALERTS_SETTINGS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchCustomerLogo = (customerId) => {
  return async (dispatch, getState) => {
    if (!customerId) {
      return;
    }

    dispatch({ type: FETCH_CUSTOMER_LOGO_REQUEST });

    try {
      const state = getState();

      // Get customer from customers list in state
      const customers = state.leaksList?.customers;
      if (!customers || !customers.items || !customers.indexMap) {
        dispatch({
          type: FETCH_CUSTOMER_LOGO_FAILURE,
          error: 'Customers not loaded',
        });
        return { status: false };
      }

      const customerIndex = customers.indexMap[customerId];
      if (customerIndex === undefined) {
        dispatch({
          type: FETCH_CUSTOMER_LOGO_FAILURE,
          error: 'Customer not found in state',
        });
        return { status: false };
      }

      const customer = customers.items[customerIndex];

      // Check if customer has logo
      if (!customer.S3Bucket || !customer.Logo) {
        dispatch({
          type: FETCH_CUSTOMER_LOGO_FAILURE,
          error: 'Customer has no logo configured',
        });
        return { status: false };
      }

      // Get signed URL using the customer's S3Bucket and Logo (same as CustomerDetails)
      dispatch(
        getSignedUrlForFile(
          customer.S3Bucket,
          customer.Logo,
          async (signedUrlResponse) => {
            if (!signedUrlResponse.status || !signedUrlResponse.data) {
              dispatch({
                type: FETCH_CUSTOMER_LOGO_FAILURE,
                error: 'Failed to get signed URL',
              });
              return;
            }

            const signedUrl = signedUrlResponse.data;

            try {
              // Fetch the actual image from the signed URL
              const imageResponse = await fetch(signedUrl);

              if (imageResponse.ok) {
                const base64 = await imageResponse.text();

                dispatch({
                  type: FETCH_CUSTOMER_LOGO_SUCCESS,
                  payload: base64,
                });
              } else {
                dispatch({
                  type: FETCH_CUSTOMER_LOGO_FAILURE,
                  error: 'Failed to fetch image from S3',
                });
              }
            } catch (error) {
              dispatch({
                type: FETCH_CUSTOMER_LOGO_FAILURE,
                error: 'Failed to download image: ' + error.message,
              });
            }
          }
        )
      );

      return { status: true };
    } catch (error) {
      dispatch({
        type: FETCH_CUSTOMER_LOGO_FAILURE,
        error: error.message,
      });
      return { status: false };
    }
  };
};

export const fetchDeviceTypesStatsWeekly = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_DEVICE_TYPES_STATS_WEEKLY_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/deviceTypesStatsWeekly/${projectId}`;

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_DEVICE_TYPES_STATS_WEEKLY_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch device types stats weekly';
        dispatch({
          type: FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_DEVICE_TYPES_STATS_WEEKLY_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchMaintenanceDashboard = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_MAINTENANCE_DASHBOARD_REQUEST });

    try {
      const path = `${DASHBOARD_ENDPOINT}/maintenance/${projectId}`;
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        dispatch({
          type: FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
          payload: response.data,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch maintenance dashboard data';
        dispatch({
          type: FETCH_MAINTENANCE_DASHBOARD_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_MAINTENANCE_DASHBOARD_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const fetchMaintenanceReportSensors = (projectId) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_MAINTENANCE_REPORT_SENSORS_REQUEST,
    });

    try {
      const path = `${DASHBOARD_ENDPOINT}/maintenance/${projectId}/report`;
      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const response = await fetchMiddleware(path, options, getState);

      if (response.status) {
        const countMap = {
          audioProblems: 0,
          fmReceptionProblems: 0,
          noFm: 0,
          batteryIssue: 0,
          inactive: 0,
        };

        const systemStatusCount = {
          sensors_replace: 0,
          audio_problems: 0,
          to_check: 0,
        };
        const projectsList = getState().leaksList?.projectsList;
        const projectIndex = projectsList?.projectIndexMap?.[projectId];
        const project =
          projectsList?.items?.[projectIndex] ||
          projectsList?.items?.find(
            (item) => String(item?.ID) === String(projectId)
          );
        const configuredThreshold = Number(
          project?.SensorActivityRatioDaysBack
        );
        // Keep the legacy value only while the selected project's settings are
        // unavailable; a configured threshold of 0 is valid and must be used.
        const inactiveThreshold =
          Number.isFinite(configuredThreshold) && configuredThreshold >= 0
            ? configuredThreshold
            : 5;
        const reportData = response.data
          .filter(
            (item) =>
              !(
                !item.radio_sync &&
                !item.white_noise &&
                !item.low_noise &&
                !item.radio_white_noise &&
                !item.no_radio &&
                !item.low_battery &&
                item.days_inactive <= inactiveThreshold
              )
          )
          .map((item) => {
            const hasAudioProblem = item.white_noise || item.low_noise;
            const hasFmReceptionProblem =
              item.radio_sync || item.radio_white_noise;

            if (hasAudioProblem) {
              countMap.audioProblems++;
            }

            if (hasFmReceptionProblem) {
              countMap.fmReceptionProblems++;
            }

            if (item.no_radio) {
              countMap.noFm++;
            }

            if (item.low_battery) {
              countMap.batteryIssue++;
            }

            if (item.days_inactive > inactiveThreshold) {
              countMap.inactive++;
            }

            if (item.low_battery || item.no_radio) {
              systemStatusCount.sensors_replace++;
            } else if (hasAudioProblem) {
              systemStatusCount.audio_problems++;
            } else {
              systemStatusCount.to_check++;
            }

            const action = getSensorAction(item);

            return {
              ...item,
              inactive: item.days_inactive > inactiveThreshold,
              statusText:
                item.days_inactive <= inactiveThreshold ? 'Active' : 'Inactive',
              action: action,
            };
          });

        const systemStatusData = {
          audio_problems: countMap.audioProblems,
          fm_reception_problems: countMap.fmReceptionProblems,
          radio_zero: countMap.noFm,
          battery: countMap.batteryIssue,
          inactive: countMap.inactive,
          sensors_replace: systemStatusCount.sensors_replace,
          to_check: systemStatusCount.to_check,
          faulty:
            systemStatusCount.sensors_replace +
            systemStatusCount.audio_problems +
            systemStatusCount.to_check,
        };

        dispatch({
          type: FETCH_MAINTENANCE_REPORT_SENSORS_SUCCESS,
          payload: reportData,
        });

        dispatch({
          type: FETCH_MAINTENANCE_DASHBOARD_SUCCESS,
          payload: systemStatusData,
        });
      } else {
        const errorMessage =
          response.err?.message ||
          response.err ||
          response.data ||
          'Failed to fetch maintenance report sensors';
        dispatch({
          type: FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE,
          error: errorMessage,
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: FETCH_MAINTENANCE_REPORT_SENSORS_FAILURE,
        error: error.message,
      });
      throw error;
    }
  };
};

export const updateDashboardProjectName =
  (projectId, dashboardProjectName) => async (dispatch, getState) => {
    const path = `${END_POINT}/projects/${projectId}`;
    const options = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [{ field: 'dashboard_name', value: dashboardProjectName }],
      }),
    };

    const response = await fetchMiddleware(path, options, getState);

    if (!response.status) {
      return response;
    }

    let getProjectPath = PROJECTS_ENDPOINT + `/please?id=${projectId}`;

    const projectResponse = await fetchMiddleware(getProjectPath, {}, getState);

    if (!projectResponse.status) {
      return projectResponse;
    }

    const state = getState();
    const { items: projects, projectIndexMap } = state.leaksList.projectsList;

    projects[projectIndexMap[projectId]] = projectResponse.data[0];

    dispatch(receiveProjects(projects, projectIndexMap));

    return projectResponse;
  };

export const updateCustomerPotentialPipeCoverage =
  (customerId, pipeCoverage) => async (dispatch, getState) => {
    const path = `${DASHBOARD_ENDPOINT}/customer-data/${customerId}`;
    const options = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [{ field: 'pipes_potential_km', value: pipeCoverage }],
      }),
    };

    const response = await fetchMiddleware(path, options, getState);
    if (!response.status) return response;

    dispatch(fetchCustomerDashboardData(customerId));
    return response;
  };

export const updateCustomerBoughtSensors =
  (customerId, boughtSensors) => async (dispatch, getState) => {
    const path = `${DASHBOARD_ENDPOINT}/customer-data/${customerId}`;
    const options = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [{ field: 'sensors_purchased', value: boughtSensors }],
      }),
    };

    const response = await fetchMiddleware(path, options, getState);
    if (!response.status) return response;

    dispatch(fetchCustomerDashboardData(customerId));
    return response;
  };

export const updateProjectPipeCoverage =
  (projectId, pipeCoverage) => async (dispatch, getState) => {
    const path = `${DASHBOARD_ENDPOINT}/stats/${projectId}`;
    const options = {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: [{ field: 'pipes_km', value: pipeCoverage }],
      }),
    };

    const response = await fetchMiddleware(path, options, getState);

    if (!response.status) {
      return response;
    }

    const refreshResponse = await fetchMiddleware(path, {}, getState);

    if (!refreshResponse.status) {
      return refreshResponse;
    }

    dispatch({
      type: FETCH_DASHBOARD_STATS_SUCCESS,
      payload: refreshResponse.data,
    });

    return refreshResponse;
  };

const getSensorAction = (row) => {
  const batteryOrRadio = row.low_battery || row.no_radio;
  const audio = row.white_noise || row.low_noise;

  if (batteryOrRadio && audio) return 'Replace sensor + tail';
  if (batteryOrRadio) return 'Replace sensor';
  if (audio) return 'Replace Tail';
  return 'Need To Check';
};
